import React from 'react';
import PropTypes from 'prop-types';

//#region //// DUCKS ////
import { SUPPORTED_IMG_TYPES } from './constants';
import './styles.scss';
//#endregion

function NoImage({
  contentNoImageProps = {},
  classNameProps = "",
  imageMode = SUPPORTED_IMG_TYPES.POSTER,
}) {


  return (
      <svg  className={classNameProps+' tbxNoImage__svg tbxNoImage__svg__'+imageMode} viewBox={"0 0 "+contentNoImageProps.width+" "+contentNoImageProps.height} style={{ "width": "100%", height: "100%"}}>
        <defs>
          <linearGradient id="myGradient" gradientTransform="rotate(90)">
            <stop offset="5%" stop-color={contentNoImageProps.backgroundColorOne} />
            <stop offset="95%" stop-color={contentNoImageProps.backgroundColorTwo} />
          </linearGradient>
        </defs>
        <rect style={{'width': '100%','height': '100%'}} fill="url('#myGradient')" />
      </svg>
  )
}

NoImage.propTypes = {
  contentNoImageProps: PropTypes.object,
  classNameProps: PropTypes.string,
  imageMode: PropTypes.oneOf(Object.values(SUPPORTED_IMG_TYPES))
};


export default React.memo(NoImage);